(() => {
    if (!window.QubitContact) {
        return;
    }

    const form = document.querySelector('.contact-form');
    if (!form) {
        return;
    }

    const status = form.querySelector('.contact-form__status');
    const submitButton = form.querySelector('button[type="submit"]');

    const setStatus = (message, state) => {
        if (!status) {
            return;
        }
        status.textContent = message || '';
        status.classList.remove('is-success', 'is-error');
        if (state) {
            status.classList.add(state);
        }
    };

    const setBusy = (isBusy) => {
        form.classList.toggle('is-submitting', isBusy);
        if (submitButton) {
            submitButton.disabled = isBusy;
            submitButton.setAttribute('aria-busy', isBusy ? 'true' : 'false');
        }
    };

    form.addEventListener('submit', async (event) => {
        event.preventDefault();
        setStatus('', null);

        if (!form.checkValidity()) {
            form.reportValidity();
            return;
        }

        const payload = {
            name: form.querySelector('[name="name"]')?.value?.trim() || '',
            email: form.querySelector('[name="email"]')?.value?.trim() || '',
            phone: form.querySelector('[name="phone"]')?.value?.trim() || '',
            subject: form.querySelector('[name="subject"]')?.value?.trim() || '',
            message: form.querySelector('[name="message"]')?.value?.trim() || '',
            department: form.querySelector('[name="department"]')?.value?.trim() || '',
            website: form.querySelector('[name="website"]')?.value?.trim() || '',
            page: form.querySelector('[name="page"]')?.value || '',
        };

        const successMessage = form.dataset.success || QubitContact.successMessage;
        const errorMessage = form.dataset.error || QubitContact.errorMessage;

        if (payload.website) {
            setStatus(successMessage, 'is-success');
            form.reset();
            return;
        }

        if (!payload.name || !payload.email || !payload.message) {
            setStatus(QubitContact.requiredMessage || errorMessage, 'is-error');
            return;
        }

        setBusy(true);

        try {
            const body = new URLSearchParams({
                action: 'qubit_contact_form',
                nonce: QubitContact.nonce,
                ...payload,
            });

            const response = await fetch(QubitContact.ajaxUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                },
                credentials: 'same-origin',
                body: body.toString(),
            });

            let data = null;
            try {
                data = await response.json();
            } catch (parseError) {
                data = null;
            }
            if (!response.ok || !data?.success) {
                const message = data?.data?.message || data?.message || errorMessage;
                throw new Error(message);
            }

            setStatus(data?.data?.message || successMessage, 'is-success');
            form.reset();
        } catch (error) {
            setStatus(error?.message || errorMessage, 'is-error');
        } finally {
            setBusy(false);
        }
    });
})();
